import { render, staticRenderFns } from "./OpenAIIntegration.vue?vue&type=template&id=4bceae05&scoped=true&"
import script from "./OpenAIIntegration.vue?vue&type=script&lang=js&"
export * from "./OpenAIIntegration.vue?vue&type=script&lang=js&"
import style0 from "./OpenAIIntegration.vue?vue&type=style&index=0&id=4bceae05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bceae05",
  null
  
)

export default component.exports